import React from 'react';
import { Link } from 'react-router-dom';
import { categoryItemPropTypes } from 'core/propTypes/componentProps';

const CategoryItem = ({ category, isSelected, onSelect }) => {
    return (
        <div className="px-2">
            <div
                className={`ltn__category-item  ltn__category-item-5 text-center shadow-sm border border-light ${isSelected ? 'active' : ''}`}
                style={{ cursor: 'pointer', width: '100%', position: 'relative' }}
            >
                <Link
                    href="#"
                    className="p-3 d-flex flex-column align-items-center"
                    onClick={(e) => {
                        e.preventDefault();
                        onSelect(category.value);
                    }}
                >
                    <span className="category-icon mb-2  d-flex justify-content-center align-items-center">
                        <i className={category.icon} />
                    </span>
                    <span
                        className="category-title text-truncate d-block"
                        style={{
                            fontSize: '0.9rem',
                            maxWidth: '100%',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {category.value}
                    </span>
                    {isSelected && (
                        <span className="category-btn d-flex justify-content-center align-items-center"
                            style={{
                                position: 'absolute',
                                bottom: '-25px',
                                left: '50%',
                                transform: 'translateX(-50%)'
                            }}>
                            <i className="fa fa-check" />
                        </span>
                    )}
                </Link>
            </div>
        </div>
    );
};

export default CategoryItem;